import { cn } from '@/lib/utils';

import { ArticleObject } from '@/models/Articles';

import UnstyledLink from '../links/UnstyledLink';
import NextImage from '../NextImage';

export default function FeaturedArticles(props: ArticleObject) {
  const {
    title,
    slug = '#',
    featuredImage,
    titleSize = 'large',
    titleSpan = '8',
    className,
    ...rest
  } = props;

  return (
    <article
      className={cn(
        'featured-article relative col-span-12 flex min-h-64 flex-col justify-end overflow-hidden rounded-2xl md:min-h-0',
        className,
        [
          titleSpan === '1' && 'xl:col-span-1',
          titleSpan === '2' && 'xl:col-span-2',
          titleSpan === '4' && 'xl:col-span-4',
          titleSpan === '8' && 'xl:col-span-8',
        ],
      )}
      {...rest}
    >
      <UnstyledLink
        href={slug}
        className='flex h-full w-full flex-col justify-end rounded-2xl focus:outline-none focus-visible:ring-4 focus-visible:ring-inset'
      >
        {title && (
          <div
            className={cn(
              'featured-article__title pointer-events-none relative z-10 grid-cols-12 items-center overflow-hidden md:grid',
              [
                titleSize === 'medium' &&
                  'p-4 md:min-h-28 md:px-6 md:py-8 lg:min-h-32',
                titleSize === 'large' && 'p-4 md:px-8 md:py-12',
              ],
            )}
          >
            <span
              className={cn('h4 font-primary text-2xl sm:leading-relaxed', [
                (titleSpan === '1' || titleSpan === '2' || titleSpan === '4') &&
                  'md:col-span-10',
                titleSpan === '8' && 'col-span-8',
              ])}
            >
              {title}
            </span>
          </div>
        )}
        {featuredImage?.node?.sourceUrl ? (
          <NextImage
            useSkeleton
            src={featuredImage?.node?.sourceUrl}
            alt={featuredImage?.node?.altText || ''}
            fill
            className='pointer-events-none absolute bottom-0 left-0 -z-10 h-full w-full object-cover object-center'
            sizes='(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 914px'
          />
        ) : (
          <div className='pointer-events-none absolute bottom-0 left-0 -z-10 flex h-full w-full items-center justify-center bg-white pb-20'>
            <NextImage
              useSkeleton
              src='/images/knowledge-transfer-gray.svg'
              alt='Knowledge Transfer Acceleration Innovation'
              className='opacity-80'
              width='190'
              height='54'
            />
          </div>
        )}
      </UnstyledLink>
    </article>
  );
}
